import { useModelContext } from '@app/contexts/model';
import { useStorageUserListContext } from '@app/modules/SelfConfig/contexts/storage';
import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FC } from 'react';

type TProps = {};

export const TargetLanguage: FC<TProps> = observer((props: TProps) => {
    const { usersListStore } = useStorageUserListContext();
    const { languageModel } = useModelContext();

    const categoryLangResponse = languageModel.dataCategory.get();

    const handleToggle = (value: string) => () => {
        if (usersListStore.targetLanguagesChosenIdSet.includes(value)) {
            usersListStore.targetLanguagesChosenIdSet.remove(value);
        } else {
            usersListStore.targetLanguagesChosenIdSet.push(value);
        }
    };

    return (
        <List className={'langChoice__targetList'}>
            <Typography>
                Target languages selection
                <br />
                (select at least one)
            </Typography>
            {categoryLangResponse &&
                categoryLangResponse.target.map((value) => {
                    const labelId = `checkbox-list-label-${value.key}`;
                    return (
                        <ListItemButton key={value.key} role={undefined} onClick={handleToggle(value.key)} dense>
                            <ListItemIcon>
                                <Checkbox edge='start' checked={usersListStore.targetLanguagesChosenIdSet.includes(value.key)} tabIndex={-1} disableRipple inputProps={{ 'aria-labelledby': labelId }} />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={`${value.name}`} />
                        </ListItemButton>
                    );
                })}
        </List>
    );
});
